module.exports = __webpack_public_path__ + "static/mca-wireframes-02.8c360527.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/mca/mca-wireframes-02.png
// module id = 478
// module chunks = 181542127041897